import classNames from "classnames"
import type { Ref } from "react"
import { forwardRef } from "react"

import styles from "./SelectButton.module.scss"
import { UnstyledInput } from "src/inputs/UnstyledInputs"
import type { InputLabelProps } from "src/types"

export type Props = InputLabelProps

/*
 * select button is actually a label with a hidden input
 */
export const SelectButton = forwardRef<HTMLLabelElement, Props>(
  function SelectButton(props: Props, propRef: Ref<HTMLLabelElement>) {
    const {
      checked,
      disabled,
      htmlFor,
      inputRef,
      name: inputName,
      onChange,
      required,
      value,
      ...htmlProps
    } = props

    const className = classNames(
      props.className,
      styles.selectButton,
    )

    return (
      <>
        <UnstyledInput
          checked={checked}
          className={styles.selectButtonInput}
          disabled={disabled}
          id={htmlFor}
          name={inputName}
          onChange={onChange}
          ref={inputRef}
          required={required}
          type="radio"
          value={value}
        />
        <label
          {...htmlProps}
          htmlFor={htmlFor}
          ref={propRef}
          className={className}
        >
          <span className={styles.selectButtonChildren}>
            {htmlProps.children}
          </span>
          <span className={styles.selectButtonHiddenChildren}>
            {htmlProps.children}
          </span>
        </label>
      </>
    )
  },
)
